import { atom } from 'recoil';
import { ITipoDeAcao } from '../../commons/types/acoes';

export const tipoDeAcaoAtom = atom<ITipoDeAcao[]>({
  key: 'tipoDeAcao',
  default: [] as ITipoDeAcao[],
});
